import {Component} from 'react';
import config from '../config.json';
import {Navigate} from "react-router-dom";

class Register extends Component {

    constructor(props) {
        super(props);
        this.state = {
            author: null,
            email: null,
            surname: null,
            name: null,
            companyName: null
        };
        this.createAccount = this.createAccount.bind(this);
    }

    createAccount = (event) => {
        event.preventDefault();
        if (!this.state.email || !this.state.name || !this.state.surname || !this.state.companyName)
            return;
        fetch(config.serverUrl_local + `/wine/author`,
            {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    pseudo: this.state.email,
                    name: this.state.name,
                    surname: this.state.surname,
                    group: {
                        name: this.state.companyName
                    }
                })
            }).then(async response => {
            const data = await response.json();
            // check for error response
            if (!response.ok) {
                // get error message from body or default to response statusText
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
            this.setState({author: data});
        })
            .catch(error => {
                this.setState({errorMessage: error.toString()});
                console.error('There was an error!', error);
            });
    }

    render() {
        return <>
            <div className="container">
                {this.state.author && (
                    <Navigate to="/wine-list" replace={true}/>
                )}

                <div className="d-flex flex-column align-items-center justify-content-center  vh-100">
                    <fieldset className="fieldset-custom border p-3">
                        <div className="header-logo align-bottom"><legend className="w-auto">Le vin est un voyage</legend></div>
                        {/*<legend className="w-auto">Entrez vos détails</legend>*/}
                    <form onSubmit={this.createAccount} className="form-white form-login form-width ">
                        <div className="form-group align-items-start">
                            <label className="display-start m-2" htmlFor="email">Email</label>
                            <input type="email" className="form-control form-control-lg p-2" id="email"
                                   onChange={event => this.setState({email: event.target.value})}
                                   placeholder="Votre adresse email"/>
                        </div>
                        <div className="form-group">
                            <label className="display-start m-2" htmlFor="name">Nom</label>
                            <input type="text" className="form-control form-control-lg p-2" id="name"
                                   onChange={event => this.setState({name: event.target.value})}
                                   placeholder="Votre nom"/>
                        </div>
                        <div className="form-group">
                            <label className="display-start m-2" htmlFor="lastName">Prénom</label>
                            <input type="text" className="form-control form-control-lg p-2" id="lastName"
                                   onChange={event => this.setState({surname: event.target.value})}
                                   placeholder="Votre prénom"/>
                        </div>
                        <div className="form-group">
                            <label className="display-start m-2" htmlFor="companyName">Entreprise</label>
                            <input type="text" className="form-control form-control-lg p-2" id="companyName"
                                   onChange={event => this.setState({companyName: event.target.value})}
                                   placeholder="Le nom de votre entreprise"/>
                        </div>
                        <button className="btn btn-primary m-4">Enregistrer
                        </button>
                    </form>
                        <div className="m-1">
                            <a href="mailto:contact@laleph.com">Besoin d’aide?</a>
                        </div>
                    </fieldset>
                </div>

            </div>
        </>
    }
}

export default Register